import { ICollectionBySlugQuery } from "~/src/components/collection/graphql/__generated__/CollectionBySlugQuery.generated";

export default function getInitialTabRedirect(
  counters: NonNullable<ICollectionBySlugQuery["collectionBySlug"]>["contentCounters"],
) {
  if (counters.projectsCount > 0) {
    return null;
  }

  if (counters.storiesCount > 0) {
    return "stories";
  }

  if (counters.groupsCount > 0) {
    return "discussions";
  }

  if (counters.productsCount > 0) {
    return "products";
  }
  if (counters.governmentsCount > 0) {
    return "governments";
  }

  return null;
}
